import { useSelector } from 'react-redux';

import { StoreState } from '../../../redux-helpers/types';
import { workspaceByIdSelector } from '../../redux-utils/selectors';

/**
 * Returns the workspace data for the given ID from the normalised redux store.
 * @param workspaceId - The ID of the workspace to retrieve
 */
export const useWorkspaceSelector = (workspaceId: string) => {
  return useSelector((store: StoreState) => {
    const { normalised } = store;
    return workspaceByIdSelector(normalised, workspaceId);
  });
};
